import React from 'react';
import { FieldErrors, RegisterOptions, UseFormRegister } from 'react-hook-form';

interface ITextareaField {
  id: string;
  name: string;
  label: string;
  errors: FieldErrors;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register: UseFormRegister<any>;
  validationSchema?: RegisterOptions;
  maxLength?: number;
  currentVal?: string;
  placeholder?: string;
  className?: string;
  props?: React.TextareaHTMLAttributes<HTMLTextAreaElement>;
}

const TextareaField = ({
  id,
  name,
  label,
  errors,
  register,
  validationSchema,
  maxLength,
  currentVal = '',
  className = '',
  placeholder = '',
  ...props
}: ITextareaField) => {
  const isRequired = validationSchema?.required;
  const length = currentVal.length;
  const showError = Boolean(errors[name]);

  return (
    <div className={className}>
      <div className="flex justify-between items-start mb-2.5 flex-wrap gap-1">
        <label htmlFor={id} className="text-gray-700 font-medium text-sm leading-normal">
          {label}
        </label>
        {maxLength && !showError && (
          <span className={`text-sm ${isRequired && length === 0 ? 'text-red-500' : 'text-gray-500'}`}>
            {length}/{maxLength}
          </span>
        )}
        {showError && (
          <span className="text-red-500 text-sm">{errors[name]?.message as string}</span>
        )}
      </div>
      <textarea
        id={id}
        placeholder={placeholder}
        {...props}
        className={`w-full h-[calc(100%-1rem)] min-h-[100px] p-3 rounded-lg border ${showError ? 'border-red-500' : 'border-gray-300'} text-gray-700 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-blue-400 transition`}
        {...register(name, validationSchema)}
      />
    </div>
  );
};

export default TextareaField;
